import { useLayoutEffect, useRef, type ReactNode } from "react";

export interface MainProps {
    cacheKey: string;
    children: ReactNode;
    title?: string;
}

/** 主内容容器，统一保留旧 Vue 页面内容区的滚动和内边距入口。 */
export function Main({ cacheKey, children, title }: MainProps) {
    const mainRef = useRef<HTMLElement>(null);
    const scrollPositionsRef = useRef(new Map<string, number>());

    useLayoutEffect(() => {
        const main = mainRef.current;
        if (!main) return;

        // 页面重新激活时恢复各自的主滚动区；表格横向滚动由缓存 DOM 原样保留。
        main.scrollTop = scrollPositionsRef.current.get(cacheKey) || 0;
        return () => {
            scrollPositionsRef.current.set(cacheKey, main.scrollTop);
        };
    }, [cacheKey]);

    return (
        <main ref={mainRef} className="layout-main-container">
            {title ? <div className="route-title">{title}</div> : null}
            {children}
        </main>
    );
}

export default Main;
